<template>
    <div class="inner-environment">
        <common-title-panel title="실내 환경 요소 비교"></common-title-panel>
        <div class="gauges">
            <div class="environmentItem">
                <GaugeChart ref="tempGauge" :data="tempGaugeData" />
                <div class="descriptionText">겨울(20°C~24°C 권장), 여름(23°C~26°C 권장)</div>
                <inner-enviroment-comp-table
                    :data="data.chartData.indoorTemp"
                    :timeDsvn="timeDsvn"
                ></inner-enviroment-comp-table>
            </div>
            <div class="environmentItem">
                <GaugeChart ref="humiGauge" :data="humiGaugeData" />
                <div class="descriptionText">상대 습도(40%~60% 권장)</div>
                <inner-enviroment-comp-table
                    :data="data.chartData.indoorHumi"
                    :timeDsvn="timeDsvn"
                ></inner-enviroment-comp-table>
            </div>
            <div class="environmentItem">
                <GaugeChart ref="co2Gauge" :data="co2GaugeData" />
                <div class="descriptionText">CO2 관리 기준 (1000ppm 이하, 환경부)</div>
                <inner-enviroment-comp-table
                    :data="data.chartData.CO2"
                    :timeDsvn="timeDsvn"
                ></inner-enviroment-comp-table>
            </div>
            <div class="environmentItem">
                <GaugeChart ref="pmGauge" :data="pmGaugeData" />
                <div class="descriptionText">초미세먼지 관리 기준(40㎍/㎥ 이하, 환경부)</div>
                <inner-enviroment-comp-table
                    :data="data.chartData['PM2.5']"
                    :timeDsvn="timeDsvn"
                ></inner-enviroment-comp-table>
            </div>
        </div>
    </div>
</template>

<script>
import GaugeChart from "../charts/GaugeChart.vue";
import InnerEnviromentCompTable from "../tables/InnerEnviromentCompTable.vue";
import CommonTitlePanel from "./CommonTitlePanel.vue";
import gaugeChart from "./gaugeChart";

export default {
    components: {
        GaugeChart,
        InnerEnviromentCompTable,
        CommonTitlePanel,
    },
    props: ["data", "timeDsvn"],
    computed: {
        tempGaugeData() {
            return {
                series: [
                    gaugeChart.createGaugeSeries({
                        min: 0,
                        max: 50,
                        splitNumber: 5,
                        axisLineColor: [
                            [0.2, "#FFEBEE"],
                            [0.4, "#EF9A9A"],
                            [0.6, "#EF5350"],
                            [0.8, "#D32F2F"],
                            [1.0, "#B71C1C"],
                        ],
                        titleText: "Temperature (°C)",
                        detailFormatter: "{value} °C",
                        data: [
                            {
                                value:
                                    this.timeDsvn == "MONTH"
                                        ? this.data.chartData.indoorTemp.currentMonth.AVG
                                        : this.data.chartData.indoorTemp.currentYear.AVG,
                                name: "온도",
                            },
                        ],
                    }),
                ],
            };
        },
        humiGaugeData() {
            return {
                series: [
                    gaugeChart.createGaugeSeries({
                        min: 0,
                        max: 100,
                        splitNumber: 5,
                        axisLineColor: [
                            [0.2, "#E1F5FE"],
                            [0.4, "#81D4FA"],
                            [0.6, "#29B6F6"],
                            [0.8, "#0288D1"],
                            [1.0, "#01579B"],
                        ],
                        titleText: "Humidity (%)",
                        detailFormatter: "{value} %",
                        data: [
                            {
                                value:
                                    this.timeDsvn == "MONTH"
                                        ? this.data.chartData.indoorHumi.currentMonth.AVG
                                        : this.data.chartData.indoorHumi.currentYear.AVG,
                                name: "습도",
                            },
                        ],
                    }),
                ],
            };
        },
        co2GaugeData() {
            return {
                series: [
                    gaugeChart.createGaugeSeries({
                        min: 0,
                        max: 2000,
                        splitNumber: 10,
                        axisLineColor: [
                            [0.2, "#ECEFF1"],
                            [0.4, "#B0BEC5"],
                            [0.6, "#78909C"],
                            [0.8, "#455A64"],
                            [1.0, "#263238"],
                        ],
                        titleText: "CO₂ (ppm)",
                        detailFormatter: "{value} ppm",
                        data: [
                            {
                                value:
                                    this.timeDsvn == "MONTH"
                                        ? this.data.chartData.CO2.currentMonth.AVG
                                        : this.data.chartData.CO2.currentYear.AVG,
                                name: "CO₂",
                            },
                        ],
                    }),
                    gaugeChart.createGaugeSeries({
                        center: ["50%", "80%"],
                        min: 0,
                        max: 2000,
                        splitNumber: 10,
                        pointerOpacity: 0.9,
                        axisLineColor: [[1, "transparent"]],
                        pointerOffsetCenter: [0, "-60%"],
                        pointerColor: "#E5E7EB",
                        axisTick: { show: false },
                        splitLine: { show: false },
                        axisLabel: { show: false },
                        title: { show: false },
                        detail: { show: false },
                        data: [
                            {
                                value: 1000,
                                name: "CO2-2",
                            },
                        ],
                    }),
                ],
            };
        },
        pmGaugeData() {
            return {
                series: [
                    gaugeChart.createGaugeSeries({
                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        axisLineColor: [
                            [0.2, "#F1F8E9"],
                            [0.4, "#C5E1A5"],
                            [0.6, "#9CCC65"],
                            [0.8, "#689F38"],
                            [1.0, "#33691E"],
                        ],
                        titleText: "PM2.5 (µg/m³)",
                        detailFormatter: "{value} µg/m³",
                        data: [
                            {
                                value:
                                    this.timeDsvn == "MONTH"
                                        ? this.data.chartData["PM2.5"].currentMonth.AVG
                                        : this.data.chartData["PM2.5"].currentYear.AVG,
                                name: "PM2.5",
                            },
                        ],
                    }),
                    gaugeChart.createGaugeSeries({
                        center: ["50%", "80%"],

                        min: 0,
                        max: 100,
                        splitNumber: 10,
                        axisLineColor: [[1, "transparent"]],
                        pointerOffsetCenter: [0, "-60%"],
                        pointerOpacity: 0.9,
                        pointerColor: "#E5E7EB",
                        axisTick: { show: false },
                        splitLine: { show: false },
                        axisLabel: { show: false },
                        title: { show: false },
                        detail: { show: false },
                        data: [
                            {
                                value: 40,
                                name: "PM2.5-2",
                            },
                        ],
                    }),
                ],
            };
        },
    },
    methods: {
        resizeGaugeCharts() {
            this.$refs.tempGauge.resizeChart();
            this.$refs.humiGauge.resizeChart();
            this.$refs.co2Gauge.resizeChart();
            this.$refs.pmGauge.resizeChart();
        },
    },
};
</script>

<style scoped>
.gauges {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: space-around;
}

.environmentItem {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 25%;
    padding: 0 20px;
    height: 250px;
}

.descriptionText {
    text-align: center;
    margin-bottom: 10px;
}
</style>
